import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface NavItem {
  title: string;
  url: string;
  icon: string;
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private appPagesSubject = new BehaviorSubject<NavItem[]>([
    {
      title: 'Все устройства',
      url: '/main/devices/0',
      icon: 'apps-outline'
    }
  ]);

  appPages$ = this.appPagesSubject.asObservable();

  constructor() { }

  updPages(newPages: NavItem[]) {
    let currentPages = this.appPagesSubject.value;

    newPages.forEach(new_page => {
      let duplicates = false
      currentPages.forEach(page => {
        if (page.title === new_page.title) {
          duplicates= true;
          return;
        } 
      });
      if (!duplicates) {currentPages.push(new_page)}
    })      
    this.appPagesSubject.next(currentPages);
  }

  clearExceptFirst() {
    const currentPages = this.appPagesSubject.value;
    if (currentPages.length > 0) {
      this.appPagesSubject.next([currentPages[0]]);
    }
  }
}
